"use client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { login } from "@/lib/auth/auth";
import { useState } from "react";
import { CircleX } from "lucide-react";
import { useRouter } from "next/navigation";

export default function Login() {
  const router = useRouter();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  return (
    <form
      className="h-screen flex flex-col items-center justify-center w-full gap-4"
      onSubmit={async (e) => {
        e.preventDefault();
        setError(false);

        const user = await login(username, password);

        setError(!user);

        if (user) {
          router.push("/");
        }
      }}
    >
      <h1 className="text-3xl font-extrabold text-foreground text-center">
        Dorf Cloud
        <br />
        <span className="text-muted-foreground text-lg font-normal">Login</span>
      </h1>
      <Input
        type="text"
        placeholder="Username"
        autoComplete="username"
        autoFocus
        className="w-full max-w-[20rem]"
        value={username}
        onInput={(e) => setUsername((e.target as HTMLInputElement).value)}
      />
      <Input
        type="password"
        placeholder="Password"
        autoComplete="current-password"
        className="w-full max-w-[20rem]"
        value={password}
        onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
      />
      <Button type="submit" variant="default" className="w-full max-w-[20rem]">
        Login
      </Button>
      <p className="text-lg text-destructive min-h-[2rem]">
        {error && (
          <>
            <CircleX className="w-5 h-5 inline align-sub mr-1" />
            Invalid password
          </>
        )}
      </p>
    </form>
  );
}
